import axios from 'axios'
import API from '@/utils/ApiConfig'
import { store } from '../store/store'
import router from '../router'

const extractErrorMessage = (response) => {
  if (response.hasOwnProperty('data')) {
    return response.data.meta.message
  } else {
    return response.meta.message
  }
}

const getApiToken = () => {
  const apiToken = localStorage.getItem('flApiToken')
  let userData = localStorage.getItem('flUserData')
  if (userData) {
    userData = JSON.parse(atob(userData))
  }
  return { apiToken, userData }
}

export const getAxios = (config = null) => {
  if (config !== null) {
    return axios.create(config)
  } else {
    const token = getApiToken().apiToken
    let headers

    if (token !== '') {
      headers = {
        'Authorization': `Bearer ${token}`,
        'Content-Type': API.CONFIG.headers['Content-Type']
      }
    } else {
      headers = {
        'Content-Type': API.CONFIG.headers['Content-Type']
      }
    }
    const defaultConfig = {
      baseURL: API.SERVER,
      timeout: API.CONFIG.timeout,
      withCredentials: API.CONFIG.withCredentials,
      headers: headers
    }

    const instance = axios.create(defaultConfig)

    instance.interceptors.response.use(function (response) {
      return response
    }, function (error) {
      if (error.response.status === 401) {
        store.dispatch('logout')
        router.push(API.LOGIN)
      }
      return Promise.reject(error)
    })

    return instance
  }
}

export default {
  extractErrorMessage: extractErrorMessage,
  buildUrlParams (map, built = '') {
    if (built.length > 0) {
      built += '&'
    }
    for (var key in map) {
      if (map.hasOwnProperty(key)) {
        built += key + '=' + encodeURIComponent(map[key]) + '&'
      }
    }
    if (built.charAt(built.length - 1) === '&') {
      built = built.substring(0, built.length - 1)
    }
    return built
  },
  userHasPermission (user, permission) {
    if (!user || !permission || !user.permissions.length) {
      return false
    }
    return user.permissions.includes(permission)
  },
  getApiToken: getApiToken,
  setApiToken (apiToken, userData = {}) {
    localStorage.setItem('flApiToken', apiToken)
    localStorage.setItem('flUserData', btoa(JSON.stringify(userData)))
    return true
  },
  setUser (userData = {}) {
    localStorage.setItem('flUserData', btoa(JSON.stringify(userData)))
    return true
  },

  unsetApiToken () {
    localStorage.removeItem('flApiToken')
    localStorage.removeItem('flUserData')
    return true
  }
}



// WEBPACK FOOTER //
// ./src/utils/Utils.js